<template>
  <div class='lm-engine'>
    <h2>MoPaaS 大模型应用引擎</h2>
    <div class="box">
      <div class="content">MoPaaS 大模型应用引擎基于用户私有大模型或第三方大模型，提供知识增强生成 (RAG) 和智能体 (Agent) 能力，用户可以低代码轻松快捷地构建和运行大模型AI原生应用。</div>
      <img src="../../assets/images/lm-engine-h5.png"/>
    </div>
    </div>
</template>

<script>
export default {
  name: 'LmIntrodution'
}
</script>

<style>
.lm-engine {
  background: #ffffff;
  padding: 6vw 3vw;
}

.lm-engine h2 {
  margin: 0 auto 6vw;
  font-size: 16px;
  font-weight: 500;
  color: #3A3F4D;
  line-height: 20px;
}

.lm-engine .box {
  width: 100vw;
}

.lm-engine .box img {
  width: 94vw;
  height: 55vw;
  margin-top: 2vh;
}
.lm-engine .content {
  font-size: 12px;
  font-weight: 400;
  color: #333333;
  line-height: 18px;
  text-align: left;
  margin: 4vw 2vw 0;
}
</style>
<style></style>


// WEBPACK FOOTER //
// src/page/h5/lm-engine.vue